import React from 'react';
import { Tab, Tabs, Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import generic10 from 'assets/img/generic/10.jpg';
import generic12 from 'assets/img/generic/12.jpg';

const Biografy = () => {
 return (
  <>
   <PageHeader title="Quienes Somos" description="Nuestra definicion intuitiva es la Mejora Continua" className="mb-3 mt-2 " />
   <Tabs variant="pills" defaultActiveKey="1" id="uncontrolled-tab-example" className="mb5 justify-content-center">
    <Tab eventKey="1" title="Historia" className="border p-3">
     <Card lg={9} sm={12}>
      <Card.Img height="400x" width="800px" src={generic10} variant="top" />
      <Card.Body>
       <Card.Title as="h1">Nuestra Historia</Card.Title>
       <Card.Text>
        <p>
         Hace 3 años, Inmovilii fue fundada con una visión clara: hacer la vida de los profesionales de la industria inmobiliaria
         más fácil y eficiente. Desde entonces, hemos trabajado incansablemente para crear una solución que cumpla con esta
         misión. Nuestro software inmobiliario es una herramienta innovadora y práctica que permite un manejo ágil y eficiente de
         todo el proceso de comercialización de un proyecto.
         <br />
         <p>
          Desde la registración de clientes hasta el seguimiento de ventas y el envío de recibos en línea, Inmovilii es un aliado
          confiable en la gestión de su proyecto. Además, con la posibilidad de vincular múltiples agencias comerciales y tener
          múltiples usuarios con diferentes niveles de administración, Inmovilii es la solución perfecta para proyectos de gran
          escala. Nos enorgullece decir que en estos 3 años de trayectoria, hemos acompañado a muchas empresas en su camino hacia
          el éxito.
         </p>
        </p>
        <p>
         Hemos visto proyectos completarse con éxito y hemos ayudado a nuestros clientes a alcanzar sus metas. Nuestra oferta
         económica, con un valor accesible por mes y que incluye capacitación y soporte técnico, es una invitación a unirse a
         nuestra familia y convertirse en parte de nuestra historia de éxito. En Inmovilii, confiamos en nuestra solución y
         estamos seguros de que será un gran aporte a su proyecto. ¡Hagámoslo juntos!
        </p>
       </Card.Text>
      </Card.Body>
     </Card>
    </Tab>
    <Tab eventKey="2" title="Visión" className="border p-3">
     <Card lg={9} sm={12}>
      <Card.Img src={generic12} height="400x" width="800px" variant="top" />
      <Card.Body>
       <Card.Title as="h1">Nuestra Vision</Card.Title>
       <Card.Text>
        <p>
         En los próximos 5 años, nuestra visión en Inmovilii es convertirnos en la empresa líder en soluciones tecnológicas
         inmobiliarias a nivel mundial. Querémos brindar una experiencia única y eficiente a nuestros clientes, mejorando
         continuamente nuestros productos y servicios, para que puedan centrarse en lo que realmente importa: su negocio. Nuestro
         objetivo es simplificar el proceso de compra y venta de propiedades, a través de la implementación de tecnología
         innovadora y accesible.
        </p>
        <p>
         Será posible realizar transacciones en tiempo real, con información detallada y actualizada en todo momento. Además,
         brindaremos una amplia gama de herramientas y recursos para mejorar la gestión de proyectos, incluyendo seguimiento de
         ventas, pagos de comisiones, informes detallados y mucho más. En Inmovilii, valoramos la importancia de la colaboración y
         el trabajo en equipo, por lo que seguiremos fomentando la vinculación de múltiples agencias comerciales, permitiendo una
         comunicación más fluida y eficiente.
        </p>
        <p>
         Por último, pero no menos importante, estamos comprometidos con el medio ambiente y la sostenibilidad. Por eso,
         trabajaremos arduamente para asegurarnos de que todas nuestras operaciones y productos sean amigables con el medio
         ambiente, contribuyendo a un futuro más sostenible y justo para todos. En resumen, en Inmovilii, queremos ser más que una
         empresa de tecnología inmobiliaria. Queremos ser un aliado estratégico para nuestros clientes, ayudándoles a alcanzar sus
         metas y a crecer de manera sostenible y eficiente. ¡Esperamos ser parte de su éxito en los próximos 5 años!
        </p>
       </Card.Text>
      </Card.Body>
     </Card>
    </Tab>
   </Tabs>
  </>
 );
};
export default Biografy;
